import interceptorAxios from './InterceptorAxios';

const ServicioUsuario = {

    recuperarContrasena(objeto){
        return interceptorAxios.post('/usuario/recuperar_contrasena.json',objeto);
    },

    actualizarContrasena(objeto){
        return interceptorAxios.post('/usuario/actualizar_contrasena.json',objeto);
    },

    verificaEstatus(){
        return interceptorAxios.post('/usuario/verifica_estatus.json');
    },
    nuevoRegistro(objeto){
        return interceptorAxios.post('/usuario/nuevo_usuario.json',objeto);
    },
    obtenerGuia(url){
        let request = { method: 'post',  url: url, responseType: 'arraybuffer'
        }
        return interceptorAxios(request);
    },
    obtenerAvisoPrivacidad(){
        return interceptorAxios.post('/usuario/aviso_privacidad.json');
    },
    obtenerDatosUsuario(){
        return interceptorAxios.post('/usuario/obtener_datos.json');
    },
    actualizarDatos(usuario){
        return interceptorAxios.post('/usuario/actualizar_datos.json',usuario);
    },
    paginacion(objeto){
        return interceptorAxios.post('/usuario/paginacion.json', objeto);
    },
    registroAdmin(objeto){
        return interceptorAxios.post('/usuario/usuario_admin.json',objeto);
    },
    buscarlike(objeto){
        return interceptorAxios.post('/usuario/buscar_like.json',objeto);
    },
    buscar_reportes(objeto){
        return interceptorAxios.post('/usuario/paginacion_reportes.json',objeto);
    },
    usuario_editar_admin(objeto){
        return interceptorAxios.post('/usuario/usuario_editar_admin.json',objeto);
    }


}

export default ServicioUsuario;